import React from 'react';
import styled from 'styled-components';
import { Box, Flex, Text } from 'rebass/styled-components';
import Skeleton from '@material-ui/lab/Skeleton';

import { mediaQueries } from 'shared/styles';
import { Button } from 'shared/components';
import PublicEnv from 'shared/utils/public-env';

function ConfirmationSkeleton() {
  return (
    <ConfirmationWrap>
      <ConfirmationBox>
        <Flex mb='16px' flexWrap='nowrap' alignItems='flex-start'>
          <Box mr='18px' flexShrink={0}>
            <LogoSkeleton variant='rect' width={65} height={53} />
          </Box>
          <Box>
            <Text fontSize={17} fontWeight='bold' color='#606369' mt='6px' mb='8px'>
              <Skeleton width={75} height={19} />
            </Text>
          </Box>
        </Flex>
        <TableContainer pt='25px'>
          <Flex pb='16px' justifyContent='space-between' alignItems='center'>
            <Skeleton width={45} height={14} />
            <Skeleton width={35} height={14} />
          </Flex>
          <Flex pb='16px' justifyContent='space-between' alignItems='center'>
            <Skeleton width={35} height={14} />
            <Skeleton width={40} height={14} />
          </Flex>
          <Flex pb='23px'>
            <Skeleton width={105} height={13} />
          </Flex>
        </TableContainer>
        <Flex pt='23px' justifyContent='space-between' alignItems='center'>
          <Skeleton width={120} height={18} />
          <Skeleton width={50} height={18} />
        </Flex>

        <Button m='24px auto 25px' width={1} data-cy='place-order' data-test='place-order' data-testid='place-order'>
          Place order
        </Button>
        <Text textAlign='center' fontSize='11px' lineHeight='17px' color='#909ca7'>
          By placing an order you agree to our{' '}
          <StyledLink rel='noopener noreferrer' target='_blank' href={`${PublicEnv.consumerUrl}/terms`}>
            Terms
          </StyledLink>{' '}
          and to receive automated text messages for order updates.
        </Text>
      </ConfirmationBox>
    </ConfirmationWrap>
  );
}
export default ConfirmationSkeleton;

const LogoSkeleton = styled(Skeleton)`
  border-radius: 4px;
`;

// directly from confirmation component
const ConfirmationWrap = styled(Box)`
  padding-bottom: 0;
  position: ${(props) => (props.isEmbedded ? 'relative' : 'sticky')};
  top: 53px;

  @media ${mediaQueries.desktop} {
    padding-bottom: 50px;
    top: 0;
  }

  @media ${mediaQueries.tablet} {
    padding-bottom: 34px;
  }

  @media ${mediaQueries.largePhone} {
    background-color: #f0f3f6;
    width: 100%;
    padding-bottom: ${(props) => (props.isEmbedded ? '125px' : '34px')};
  }
`;

const ConfirmationBox = styled(Box)`
  background-color: #f0f3f6;
  border-radius: 7px;
  max-width: 307px;
  padding: 29px 25px 34px 25px;
  position: relative;

  @media ${mediaQueries.desktop} {
    margin: 0 auto;
    max-width: 390px;
  }

  @media ${mediaQueries.largePhone} {
    max-width: 450px;
    padding: 34px 30px 0 30px;
    top: 0;
  }
`;

const TableContainer = styled(Box)`
  border-top: 1px solid #d3dadf;
  border-bottom: 1px solid #d3dadf;
`;

const StyledLink = styled.a`
  color: #0b99e6;
`;
